import React from 'react';
import { styled } from '@mui/material';
import MuiAutocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import MuiPopper from '@mui/material/Popper';
import FormControl from '@mui/material/FormControl';

type StyledAutocompleteProps = AutocompleteProps<string[], boolean, boolean, boolean>;
const Input = styled(MuiAutocomplete, {
  label: 'AutocompleteInput',
})<StyledAutocompleteProps>(({ theme, value }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: 'rgba(100, 100, 100, 0.1)',
    border: `1px solid rgba(100, 100, 100, 1)`,
    borderRadius: '2px',
    padding: '13px 15px 13px!important',
    minHeight: '51px',
    boxSize: 'border-box',

    '& input': {
      fontFamily: 'Open Sans',
      fontSize: '16px',
      color: '#fff',
      padding: '0 !important',
      lineHeight: '18px',
      minHeight: '0',
    },

    '& fieldset': {
      border: 'none',
    },

    '& .MuiAutocomplete-endAdornment': {
      right: 'auto !important',
      left: '0.3rem',
    },
  },

  '& .MuiAutocomplete-popupIndicator': {
    color: '#fff',
  },
})) as typeof MuiAutocomplete;

const Popper = styled(MuiPopper, { label: 'CustomPopper' })(({ theme }) => ({
  '& .MuiPaper-root': {
    marginTop: '0px',
    borderRadius: '2px',
    backgroundColor: 'rgba(43, 44, 45, 1)',
    border: `1px solid rgba(100, 100, 100, 1)`,

    '& .MuiAutocomplete-option': {
      padding: '12px 0',
      fontSize: '16px',
      lineHeight: '18px',
      color: '#fff',
      paddingRight: '15px',
      fontFamily: 'Open Sans',
      borderBottom: '1px solid rgba(100, 100, 100, 1)',

      '&:lasy-child': {
        borderBottom: 'none',
      },

      '&:hover': {
        backgroundColor: `rgba(43, 44, 45, 1) !important`,
      },

      '&[aria-selected="true"]': {
        backgroundColor: `rgba(43, 44, 45, 1)  !important`,
      },
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
    },
  },
}));

interface Props<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  onSelectChange: (val: string) => void;
  value: any;
}

const Autocomplete = <
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
>(
  props: Props<T, Multiple, DisableClearable, FreeSolo>,
) => {
  const { value, onSelectChange, ...autocompleteInputProps } = props;

  const onChange = (event: React.BaseSyntheticEvent, value: any) => {
    onSelectChange(value);
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <Input
        {...autocompleteInputProps}
        value={value}
        PopperComponent={Popper}
        onChange={onChange}
        noOptionsText="לא נמצאו תוצאות"
      />
    </FormControl>
  );
};

export default Autocomplete;
